<template>
  <div
    class="columns-order-item"
    :class="{
      'columns-order-item_grouped': isGroup
    }"
  >
    <div
      v-if="isGroup"
      class="columns-order-item__group-info"
    >
      <MIcon
        v-if="groupInfo.icon"
        :icon="groupInfo.icon"
        class="order-item-group-info__icon"
      />
      <div class="order-item-group-info__name">
        {{ groupInfo.name }}
      </div>
    </div>

    <div
      v-for="item in richItems"
      :key="item.id"
      class="columns-order-item-value"
    >
      <div class="columns-order-item-value__name">
        {{ item.name }}
      </div>
      <div class="columns-order-item-value__remove">
        <MIcon
          v-if="!item.disabled"
          :icon="iconCross"
          @click="removeItem(item.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import iconCross from 'assets/icons/cross.svg';

  export default {
    name: 'ColumnsOrderItem',
    components: {MIcon},
    props: {
      items: {
        type: Array,
        required: true
      },
      columnsMap: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        iconCross
      };
    },
    computed: {
      richItems () {
        return this.items.map(i => this.columnsMap[i]);
      },
      groupInfo () {
        return this.richItems[0].groupInfo;
      },
      isGroup () {
        return this.groupInfo.union;
      }
    },
    methods: {
      removeItem (itemId) {
        this.$emit('removeItem', itemId);
      }
    }
  };
</script>

<style>
  .columns-order-item {
    font-size: 12px;

    color: var(--text-main-color);

    position: relative;

    padding: 5px 8px 5px 12px;

    margin: 10px 0;

    background-color: var(--background-color);
    box-shadow: 0 2px 8px rgba(176, 176, 176, 0.25);

    border-radius: 5px;
  }

  .columns-order-item_grouped {
    padding: 8px 8px 8px 12px;
  }

  .columns-order-item__group-info {
    display: flex;

    align-items: center;

    margin-bottom: 12px;
  }

  .columns-order-item-value {
    display: flex;
  }

  .columns-order-item .columns-order-item-value ~ .columns-order-item-value {
    padding-top: 8px;

    margin-top: 8px;

    border-top: solid 1px var(--border-color);
  }

  .order-item-group-info__name {
    font-weight: var(--medium-font-weight);
    color: var(--secondary-text-color);
  }

  .order-item-group-info__icon {
    width: 12px;
    height: 12px;

    margin-right: 4px;
  }

  .columns-order-item-value__remove {
    color: var(--secondary-text-color);

    cursor: pointer;

    flex-grow: 0;
    flex-shrink: 0;

    width: 14px;
    height: 14px;

    margin-left: auto;
    user-select: none;
  }
</style>
